import { Operation, Persistence, Workflow, State } from '@amzn/ihm-associate-tools-js-lib'

export class Orchestrator {

    public static get instance () {
        return this.init()
    }

    private static orchestrator: Orchestrator
    private toolWorkflowMap: Map<string, string>
    private telemEnabled: boolean

    public static init () {
        if (!Orchestrator.orchestrator) {
            Orchestrator.clear()
            Orchestrator.orchestrator = new Orchestrator()
        }
        return Orchestrator.orchestrator
    }

    private static clear () {
        localStorage.removeItem(Operation.ACTION)
        localStorage.removeItem(Operation.TASK)
        localStorage.removeItem(Operation.WORKFLOW)
    }

    public setWeblabEnabled (isEnabled: boolean) {
        this.telemEnabled = isEnabled
    }

    public isTelemEnabled () {
        return this.telemEnabled || false
    }

    public workflow (tool: string) {
        // TODO: test me!
        // each tool will receive their own workflow that comes unstarted
        // it is auto-started in the Model/Plan initialization logic
        // the "last tool" in a multi-tool workflow and/or the Task List tool
        // will be the one decide that a cross-tool flow has terminated
        // this will probably be with some State.end() function?
        // this depends on having tools already built in a workflow pattern...

        // if there's no "current" workflow, then ATBase has just loaded
        //      create one and add to map (and start it?)
        // if there is a "current" workflow, then a tool is being switched to
        //      end it forcefully
        //      check if the new tool is in the map,
        //      if so, reset (which is done via start()) and return it
        //      else, create one and add to map (and start it?)
        // set the new current workflow

        const currentWorkflow = State.getWorkflow()

        if (!currentWorkflow) {
            const firstWorkflow = new Workflow(tool)
            this.toolWorkflowMap.set(tool, firstWorkflow.id)
            Persistence._setCurrent(Operation.WORKFLOW, firstWorkflow.id)
            return
        }

        currentWorkflow.stop(true)

        if (this.toolWorkflowMap.has(tool)) {
            const workflowId = this.toolWorkflowMap.get(tool)
            Persistence._setCurrent(Operation.WORKFLOW, workflowId)
            return
        }

        const newWorkflow = new Workflow(tool)
        newWorkflow.start()
        this.toolWorkflowMap.set(tool, newWorkflow.id)

        Persistence._setCurrent(Operation.WORKFLOW, newWorkflow.id)
        Persistence._setCurrent(Operation.TASK, null)
        Persistence._setCurrent(Operation.ACTION, null)
    }

    private constructor () {
        this.toolWorkflowMap = new Map()
    }

}
